module.exports = __webpack_public_path__ + "static/media/arrows.d8640a47.svg";